import React, { Fragment } from 'react';
import type {
    StylesConfig,
    MultiValue,
    GroupBase
} from "react-select";
import Select from "react-select";
import { IoAddCircle, IoSearchSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa6";
import { SelectErrorTheme, SelectSuccessTheme } from './SelectTheme';
interface OptionType {
    value: string | number | boolean;
    label: string;
    [key: string]: any;
}

interface SelectionBoxProps {
    name: string;
    isLoading?: boolean;
    required?: boolean;
    clear?: boolean;
    menuIsOpen?: boolean;
    menuPlacement?: 'auto' | 'bottom' | 'top';
    disabled?: boolean;
    add_btn?: boolean;
    onClick?: () => void;
    focus?: boolean;
    search_btn?: boolean;
    view_click?: () => void;
    label?: string;
    placeholder?: string;
    value?: string | number | boolean;
    handleChange?: (name: string, selectedOption: OptionType | MultiValue<OptionType> | null) => void;
    handleBlur?: (e: React.FocusEvent) => void;
    touched?: boolean;
    errors?: string;
    options: OptionType[];
    isMulti?: boolean;
    view_title?: string;
}
const SelectionBox: React.FC<SelectionBoxProps> = ({
    name,
    isLoading,
    required,
    clear,
    menuIsOpen,
    menuPlacement,
    disabled,
    add_btn,
    onClick,
    search_btn,
    view_click,
    label,
    placeholder,
    value,
    handleChange,
    view_title,
    handleBlur,
    touched,
    errors,
    options,
    isMulti = false
}) => {

    const customStyles: StylesConfig<OptionType, boolean, GroupBase<OptionType>> = {
        control: (provided) => ({
            ...provided,
            backgroundColor: '#fff',
            minHeight: '28px',
            borderRadius: "3px",
            height: '28px',
            fontFamily: "Roboto, sans-serif"
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '28px',
            bottom: "3px",
            paddingBottom: '8px 0px',
            fontFamily: "Roboto, sans-serif"
        }),

        indicatorsContainer: (provided) => ({
            ...provided,
            height: '28px',
            fontFamily: "Roboto, sans-serif"
        }),
        input: (provided) => ({
            ...provided,
            fontSize: "12px",
            fontWeight: 400,
            fontFamily: "Roboto, sans-serif"
        }),
        placeholder: (provided) => ({
            ...provided,
            marginTop: "0px",
            fontSize: '12px',
            fontWeight: 400,
            color: "#6a7282 ",
            userSelect: "none",
            overflow: "hidden",
            fontFamily: "Roboto, sans-serif"
        }),
        option: (provided) => ({
            ...provided,
            fontSize: '12px',
            fontWeight: 400,
            paddingTop: 5,
            paddingBottom: 5,
            fontFamily: "Roboto, sans-serif"
        }),
    };
    return (
        <Fragment>
            <div className='w-full'>
                {label && (
                    <div className='flex justify-between w-full'>
                        <div className='flex flex-row w-full'>
                            <label className="block text-[12px] font-medium text-slate-900 mb-0.5 dark:text-slate-400 font-roboto" htmlFor={name}>
                                {label}
                            </label>
                            {!add_btn && !search_btn && required && <span className='text-red-600 text-[14px] pl-1 -mt-0.5'>*</span>}
                            {add_btn && <IoAddCircle onClick={onClick} fontSize={20} className='text-blue-600 pl-1 cursor-pointer' />}
                            {search_btn && <IoSearchSharp onClick={onClick} fontSize={20} className='text-customPrimary pl-1 cursor-pointer' />}
                        </div>
                        <div>
                            {view_click && <FaEye title={view_title} onClick={view_click} fontSize={20} className='text-green-500 pl-1 cursor-pointer' />}
                        </div>
                    </div>
                )}
                <Select<OptionType, boolean>
                    options={options}
                    isMulti={isMulti}
                    menuIsOpen={menuIsOpen}
                    openMenuOnFocus={true}
                    isClearable={clear}
                    theme={
                        errors || (errors && touched)
                            ? SelectErrorTheme
                            : SelectSuccessTheme
                    }
                    onChange={(selectedOption: any) => {
                        if (handleChange) {
                            handleChange(name, selectedOption);
                        }
                    }}
                    value={options?.find(opt => opt?.value?.toString() === value?.toString()) || null}
                    defaultValue={options?.find(opt => opt.value?.toString() === value?.toString()) || null}
                    menuPlacement={menuPlacement || 'bottom'}
                    isSearchable
                    isDisabled={disabled || false}
                    isLoading={isLoading || false}
                    className="text-[13px] w-full mt-0 pt-0 !rounded-none"
                    onBlur={handleBlur}
                    styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    placeholder={placeholder || ""}
                    required={required}
                    menuPortalTarget={document.body}
                    aria-label={label}
                />
                {errors && touched && <div className='text-red-500 text-[12px] font-public-sans mt-1'>{errors}</div>}
            </div>
        </Fragment>
    );
};

export default SelectionBox;